import { ChartArea, FileSliders, Sparkles } from 'lucide-react';

import { default as LogoCRM } from 'src/assets/images/logos/miliboo-crm-min.svg?react';
import { default as LogoPIM } from 'src/assets/images/logos/miliboo-pim-min.svg?react';
import { default as LogoSAV } from 'src/assets/images/logos/miliboo-sav-min.svg?react';
import { default as LogoTMS } from 'src/assets/images/logos/miliboo-tms-min.svg?react';

export const sidebarProjectsConfig = [
  {
    name: 'TMS',
    logo: (
      <LogoTMS
        className='rounded-md text-white'
        style={{ width: '48px', height: '48px' }}
      />
    ),
    plan: 'Transport',
    link: 'https://tms.demo.miliboo.io/login',
  },
  {
    name: 'PIM',
    logo: (
      <LogoPIM
        className='rounded-md text-white'
        style={{ width: '48px', height: '48px' }}
      />
    ),
    plan: 'Product',
    link: 'https://pim.nw.demo.miliboo.io/login',
  },
  {
    name: 'CRM',
    logo: (
      <LogoCRM
        className='rounded-md text-white'
        style={{ width: '48px', height: '48px' }}
      />
    ),
    plan: 'Commercial',
    link: 'https://commercial.nw.demo.miliboo.io/login',
  },
  {
    name: 'SAV',
    logo: (
      <LogoSAV
        className='rounded-md text-white'
        style={{ width: '48px', height: '48px' }}
      />
    ),
    plan: 'Aftersales',
    link: 'https://intra.legacy.demo.miliboo.io/sav/recherche_sav_v2.php',
  },
];

export const sidebarMainNavigationConfig = [
  {
    title: 'Forecast',
    url: '/forecast',
    icon: ChartArea,
  },
  {
    title: 'Configuration',
    url: '/configuration',
    icon: FileSliders,
  },
  {
    title: 'Novelties',
    url: '/novelties',
    icon: Sparkles,
  },
];
